import React from "react";
import BlankHeader from "../navigation/Navbar/BlankHeader";
import BlankSidebar from "../navigation/Navbar/BlankSidebar";

interface GuestLayoutProps {
  children: React.ReactNode;
  guestUser?: string;
}

const GuestLayout: React.FC<GuestLayoutProps> = ({ children, guestUser }) => {
  return (
    <>
      <BlankSidebar />
      <div className="main_content_wrapper">
        <BlankHeader guestUser={guestUser}/>
        <div className="main_content">{children}</div>
      </div>
    </>
  );
};

export default GuestLayout;
